"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledRadioInput = exports.StyledRadioLabelInner = exports.StyledRadioWrapper = exports.StyledRadioReplacement = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const models_1 = require("../../../../shared/models");
const styles_1 = require("../../../../styles");
const focusHover_1 = require("../../../../styles/focusHover");
const tokens_1 = require("../../../../styles/tokens");
const focusedRadioReplacementBorderWidthStyle = "border-width: 2px;";
const getRadioBackgroundStyles = (inputState) => {
    return `background-color: ${(0, styles_1.inputStateStyles)({ state: inputState }).backgroundColor};`;
};
const getRadioBorderStyles = (inputState) => {
    return `
        border: ${(0, styles_1.inputStateStyles)({ state: inputState }).border};
        box-shadow: none;
    `;
};
const getRadioReplacementHoverStyles = (disabled, hasErrors) => {
    if (disabled) {
        return null;
    }
    if (hasErrors) {
        return `
            ${getRadioBorderStyles(models_1.InputStates.ERROR)}
            ${focusedRadioReplacementBorderWidthStyle}
        `;
    }
    return `
       ${getRadioBorderStyles(models_1.InputStates.HOVER)}
    `;
};
const canHaveCheckPlacement = (theme) => theme === "bordered";
// Radio input - outer part of the check box
exports.StyledRadioReplacement = styled_components_1.default.span `
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: ${tokens_1.SIZES[2]};
    height: ${tokens_1.SIZES[2]};
    border-radius: 50%;
    margin-top: ${tokens_1.SIZES[0.5]};
    ${getRadioBackgroundStyles(models_1.InputStates.DEFAULT)}
    ${({ disabled, isChecked, isFocused, hasErrors }) => {
    if (disabled) {
        return getRadioBorderStyles(models_1.InputStates.DISABLED);
    }
    if (hasErrors) {
        return getRadioBorderStyles(models_1.InputStates.ERROR);
    }
    if (isFocused) {
        return getRadioBorderStyles(models_1.InputStates.FOCUS);
    }
    if (isChecked) {
        return getRadioBorderStyles(models_1.InputStates.BORDERED_SELECT);
    }
    return getRadioBorderStyles(models_1.InputStates.DEFAULT);
}}

    ${({ isFocused }) => {
    if (isFocused) {
        // This is the focus state for the radio circle
        return focusHover_1.focusBorderStyles;
    }
}}

    ${({ checkPlacement, theme }) => {
    if (canHaveCheckPlacement(theme) && checkPlacement === "top-right") {
        return "align-self: start;";
    }
}}

    /* Radio input - inner part of the check box */
    &::before {
        content: "";
        display: block;
        width: ${tokens_1.SIZES[1]};
        height: ${tokens_1.SIZES[1]};
        border-radius: 50%;
        ${({ disabled, isChecked }) => {
    if (disabled && isChecked) {
        return getRadioBackgroundStyles(models_1.InputStates.DISABLED);
    }
    // Darker background colour
    if (isChecked) {
        // We are using border color for the selected indicator to solve a
        // situation where the background disappears in high contrast mode
        return `
                border: solid ${tokens_1.SIZES[0.5]} ${tokens_1.COLOURS.primary.blue[100]};
            `;
    }
    return getRadioBackgroundStyles(models_1.InputStates.DEFAULT);
}}
    }
`;
exports.StyledRadioWrapper = styled_components_1.default.span `
    position: relative;
    display: block;
    margin-bottom: ${tokens_1.SIZES[0.5]};
    /* Padding and border */
    ${({ theme, dimension }) => {
    if (theme === "bordered") {
        return (0, styled_components_1.css) `
                padding: ${tokens_1.BUTTON_FORM_FIELDS_PADDING.text[dimension]};
                border-radius: ${tokens_1.BORDERS.radius};
            `;
    }
}}

    /* Background styles */
    ${({ theme, isChecked, disabled, hasErrors, isFocused }) => {
    if (theme === "bordered") {
        if (disabled) {
            return getRadioBackgroundStyles(models_1.InputStates.DISABLED);
        }
        if (hasErrors) {
            return getRadioBackgroundStyles(models_1.InputStates.ERROR);
        }
        if (isChecked || isFocused) {
            return `
                    ${getRadioBackgroundStyles(models_1.InputStates.HOVER)};
                    background-color: ${tokens_1.COLOURS.primary.blue[5]};
                `;
        }
        return getRadioBackgroundStyles(models_1.InputStates.DEFAULT);
    }
}}

    &:before {
        pointer-events: none;
        ${({ theme, disabled, isChecked, isFocused, hasErrors }) => {
    if (theme === "bordered") {
        if (disabled) {
            return getRadioBorderStyles(models_1.InputStates.DISABLED);
        }
        if (hasErrors) {
            return getRadioBorderStyles(models_1.InputStates.ERROR);
        }
        if (isFocused) {
            return getRadioBorderStyles(models_1.InputStates.BORDERED_FOCUS);
        }
        if (isChecked) {
            return getRadioBorderStyles(models_1.InputStates.BORDERED_SELECT);
        }
        return getRadioBorderStyles(models_1.InputStates.BORDERED_DEFAULT);
    }
}}
        ${tokens_1.BORDER_ALTERNATIVE}
        z-index: 0;
        border-radius: ${tokens_1.BORDERS.radius};
        transition: "all 0.2s ease";
    }

    &:hover {
        /*
            Bordered input:
            Adds hover state to the radio checkbox on hover of the whole box
            For traditional input the hover style is in the context of the .custom-radio-label
        */
        ${exports.StyledRadioReplacement} {
            ${({ theme, disabled, hasErrors, isFocused }) => {
    if (theme === "bordered" && !isFocused) {
        return getRadioReplacementHoverStyles(!!disabled, hasErrors);
    }
}}
        }
    }

    .custom-radio-label {
        position: relative;
        width: auto;
        display: ${({ theme }) => {
    if (theme === "bordered") {
        return "flex";
    }
    /* traditional boxes shouldn't expand to the width of the container */
    return "inline-flex";
}};
        align-items: flex-start;

        ${({ disabled, isChecked }) => {
    if (disabled || isChecked) {
        return (0, styled_components_1.css) `
                    color: ${disabled
            ? tokens_1.COLOURS.greyscale.stone
            : tokens_1.COLOURS.greyscale.zinc};
                    /* Extend the colour to all the possible JSX components passed */
                    * {
                        color: ${disabled
            ? tokens_1.COLOURS.greyscale.stone
            : tokens_1.COLOURS.greyscale.zinc};
                        fill: ${disabled
            ? tokens_1.COLOURS.greyscale.stone
            : tokens_1.COLOURS.greyscale.zinc};
                    }
                `;
    }
    return (0, styled_components_1.css) `
                /* Extend the colour to all the possible JSX components passed */
                * {
                    color: ${tokens_1.COLOURS.greyscale.night};
                    fill: ${tokens_1.COLOURS.greyscale.night};
                }
            `;
}}

        ${({ checkPlacement, theme }) => {
    if (canHaveCheckPlacement(theme) &&
        checkPlacement === "top-right") {
        return (0, styled_components_1.css) `
                    flex-direction: row-reverse;
                    justify-content: space-between;
                `;
    }
    return null;
}}

        &:hover {
            /*
                Traditional input:
                Adds hover state to the radio checkbox on hover of the label
                For traditional input the hover style is in the context of the parent of this label
            */
            ${exports.StyledRadioReplacement} {
                ${({ theme, disabled, hasErrors, isFocused }) => {
    if (theme === "traditional" && !isFocused) {
        return getRadioReplacementHoverStyles(!!disabled, hasErrors);
    }
}}
            }
        }
    }
`;
exports.StyledRadioLabelInner = styled_components_1.default.span `
    display: inline-flex;
    align-items: center;
    margin-left: ${tokens_1.SIZES[1]};
    width: 100%;

    ${({ theme, checkPlacement }) => {
    if (canHaveCheckPlacement(theme) && checkPlacement === "top-right") {
        return (0, styled_components_1.css) `
                margin-left: 0;
            `;
    }
}}
`;
exports.StyledRadioInput = styled_components_1.default.input `
    position: absolute;
    top: 0;
    opacity: 0;
    margin: 0;

    :focus {
        box-shadow: none;
    }
`;
//# sourceMappingURL=Radio.styles.js.map